// app/javascript/projects/components/CodeBookH.jsx

import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ColorConstants from 'constants/ColorConstants';
import Textarea from 'react-textarea-autosize';
import ExcerptConstants from 'constants/ExcerptConstants';
import { Link } from 'react-router-dom';
import { useAutoSaveSynthesis } from 'hooks/codes/useAutoSaveSynthesis';

const CodeBookH = ({ 
  code, 
  parent, 
  projectID, 
  collapsed, 
  hasEditPermission, 
  onCollapseClicked 
}) => {
  const {
    displayText,
    handleSynthesisChange,
    handleTextAreaFocus,
    handleTextAreaBlur
  } = useAutoSaveSynthesis(code.id, code.synthesis);

  const handleCollapseClicked = (e) => {
    onCollapseClicked(code.id);
  };

  const backgroundColor = parent ? ColorConstants.ULTRA_LIGHT_GREY : "white";

  const CollapseIcon = collapsed ? ChevronRightIcon : ExpandMoreIcon;

  const to = code?.id 
    ? `/projects/${projectID}/codes/${code.id}` 
    : `/projects/${projectID}/codes/`;

  return (
    <div
      className="code-card"
      style={{
        backgroundColor: backgroundColor,
        border: ExcerptConstants.BORDER,
        borderRadius: ExcerptConstants.BORDER_RADIUS,
        padding: ExcerptConstants.PADDING,
        paddingLeft: ExcerptConstants.PADDING,
        paddingRight: ExcerptConstants.PADDING,
        paddingTop: "20px",
        paddingBottom: "15px",
        marginTop: 10
      }}>
      <div>
        <div style={{
          float: "left", 
          width: "95%", 
          marginBottom: "0px", 
          paddingBottom: "3px"
        }}>
          <Link to={to} style={{ cursor: "pointer", display: "block", color: "inherit", textDecoration: "none" }}>
            <div style={{ margin: "0px", padding: "0px" }}>
              {parent && (
                <h3 style={{ margin: 0 }}>
                  {code.name} ({code.count})
                </h3>
              )}
              {!parent && (
                <h5 style={{ margin: 0 }}>
                  {code.name} ({code.count})
                </h5>
              )}
            </div>
          </Link>
        </div>

        {parent && code.children && code.children.length > 0 && (
          <div style={{
            float: "right", 
            marginBottom: "0px", 
            paddingBottom: "0px"
          }}>
            <CollapseIcon
              data-testid={collapsed ? "ChevronRightIcon" : "ExpandMoreIcon"}
              onMouseUp={handleCollapseClicked}
              style={{
                color: ColorConstants.LIGHT_GREY,
                cursor: "pointer",
                fontSize: 16
              }}
            />
          </div>
        )}

        <div style={{ clear: "both", margin: 0, padding: 0 }} />
      </div>

      {hasEditPermission ? (
        <Textarea 
          placeholder="Write a description or thoughts about this code"
          onChange={handleSynthesisChange}
          onFocus={handleTextAreaFocus}
          onBlur={handleTextAreaBlur}
          value={displayText || ""}
          style={{
            width: "95%",
            resize: 'none',
            outline: "none",
            borderStyle: "none",
            backgroundColor: backgroundColor,
            paddingLeft: 0,
          }}
        />
      ) : (
        <p>{displayText}</p>
      )}
    </div>
  );
};

export default CodeBookH;